import {useEffect, useRef, useState} from "react";
import {TElementOnScreen} from "hooks/useElementOnScreen/types";

const useElementOnScreen = (options: TElementOnScreen) => {
	const containerRef = useRef<HTMLElement | null>(null); // Element reference
	const [isVisible, setIsVisible] = useState<boolean>(false); // Visibility state

	useEffect(() => {
		// If no element to observe or options.shouldTrack is false, exit early
		if (!options.shouldTrack || !containerRef.current) return;

		// Create the IntersectionObserver instance
		const observer = new IntersectionObserver((entries) => {
			const [entry] = entries; // Only process the first entry
			setIsVisible(entry.isIntersecting); // Set visibility based on intersection
		}, options);

		const currentElement = containerRef.current;
		observer.observe(currentElement);

		// Cleanup function
		return () => {
			observer.unobserve(currentElement); // Stop observing the current element
			observer.disconnect(); // Disconnect the observer instance
		};
	}, [options]); // Recreate if options change

	return [containerRef, isVisible] as const; // Return reference and visibility state
};

export default useElementOnScreen;
